<template>
  <v-container id="user-profile" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="8">
        <base-material-card color="gold" inline title="Usuarios">
          <template v-slot:after-heading>
            <div class="font-weight-light card-title mt-2">
              {{ tittle }}
            </div>
          </template>
          <validation-observer v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(validateForm)">
              <v-container class="py-0">
                <v-row>
                  <v-col cols="12" md="6">
                    <validation-provider
                      v-slot="{ errors }"
                      name="nueva contraseña"
                      rules="required|max:25|min:8|password:@confirm"
                    >
                      <v-text-field
                        v-model="passwordNueva"
                        color="gold"
                        :error-messages="errors"
                        label="Nueva Contraseña *"
                        autocomplete="new-password"
                        :append-icon="showPasswordNueva ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showPasswordNueva ? 'text' : 'password'"
                        @click:append="showPasswordNueva = !showPasswordNueva"
                      />
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="6">
                    <validation-provider
                      v-slot="{ errors }"
                      name="confirm"
                      rules="required|max:25|min:8|password:@nueva contraseña"
                    >
                      <v-text-field
                        v-model="passwordCheck"
                        color="gold"
                        :error-messages="errors"
                        label="Repetir Contraseña *"
                        autocomplete="new-password"
                        :append-icon="showPasswordCheck ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showPasswordCheck ? 'text' : 'password'"
                        @click:append="showPasswordCheck = !showPasswordCheck"
                      />
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="6">
                    <validation-provider v-slot="{ errors }" name="contraseña" rules="required|max:25|min:8">
                      <v-text-field
                        v-model="dataForm.password"
                        color="gold"
                        :error-messages="errors"
                        label="Contraseña actual *"
                        autocomplete="new-password"
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showPassword ? 'text' : 'password'"
                        @click:append="showPassword = !showPassword"
                      />
                    </validation-provider>
                  </v-col>
                  <v-spacer />
                  <v-col cols="12" md="6">
                    <v-row justify="end">
                      <v-btn color="gold" class="mr-0" type="submit">
                        Cambiar
                      </v-btn>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </form>
          </validation-observer>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {

    data: () => ({
      tittle: 'Cambiar Password',
      exito: 'Password cambiado',
      showPassword: false,
      showPasswordNueva: false,
      showPasswordCheck: false,
      passwordNueva: undefined,
      passwordCheck: undefined,
      menu: false,
      showNotificar: false,
      notificar: false,
      dataForm: {
        password: '',
      },
    }),
    created () {
      this.getUserId()
    },
    methods: {
      getUserId () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/getAuthId' }).then(response => { this.dataForm.userId = response })
      },
      changePassword: async function () {
        await this.$http({
          method: 'put',
          url: '/api/usuarios_password',
          data: {
            userId: this.dataForm.userId,
            password: this.dataForm.password,
            passwordNueva: this.passwordNueva,
          },
          headers: { Authorization: 'Bearer ' + this.$store.state.token },
        }).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: [this.exito] })
          this.$router.push({ name: 'Tablero principal' })
        }).catch(error => {
          if (error.response.data.errors) {
            this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
          } else if (error.response.data === 'Contraseña invalida') {
            this.$store.commit('toast/show', { tipo: 'error', messages: [error.response.data] })
          } else {
            this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
          }
        })
      },

      validateForm (scope) {
        this.changePassword()
      },
    },
  }
</script>
